document.addEventListener('DOMContentLoaded', function () {
  if (!$('.email-preview').length) {
    return
  }

  let $root = $('.email-preview')

  let settingsShown = false

  const $toggle = $root.find('.email-preview__additional-toggle')
  const $extraSettings = $root.find('.email-preview__additional')

  $root.on('click', '.email-preview__additional-toggle', () => {
    settingsShown = !settingsShown
    $extraSettings.toggle(settingsShown)
    $toggle.text(settingsShown ? $toggle.data('hide-text') : $toggle.data('show-text'))
  })

  // Fetches email preview as html via ajax and sets the iframe contents
  const reloadPreview = () => {
    const data = $root
      .find('.email-form')
      .find('input[name!=_method], select, textarea') // this fieldcauses strange Rails issues
      .serialize()

    const $preview = $root.find('.email-preview__preview-frame')

    $preview.toggleClass('is-loading', true)

    $.ajax({
      url: '/admin/emails/preview',
      method: 'POST',
      data: data,
    }).done(rawContent => {
      const doc = $preview.get(0).contentWindow.document
      doc.open()
      doc.write(rawContent)
      doc.close()

      $preview.toggleClass('is-loading', false)
    })
  }

  const debouncedReload = _.debounce(reloadPreview, 300)
  reloadPreview()

  $root.on('input', '.email-form input, .email-form textarea', debouncedReload)
  $root.on('change', '.email-form select', reloadPreview)
  $root.on('trix-change', debouncedReload)

  $root.on('click', '.email-preview__test-send', function () {
    const $button = $root.find('.email-preview__test-send')
    const email = $root.find('.email-preview__test-email').val()
    $button.prop('disabled', true)

    const data = $root
      .find('.email-form')
      .find('input[name!=_method], select, textarea') // this fieldcauses strange Rails issues
      .serialize()

    if (!email) return

    $.ajax({
      url: `/admin/emails/test-flight?email=${email}`,
      method: 'POST',
      data: data,
    }).done(rawContent => {
      $button.prop('disabled', false)
    })
  })

  $root.on('click', '.variable', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const variable = $(this).data('variable')
    $root.find('trix-editor').get(0).editor.insertString(`{{${variable}}}`)
  })

  $root.on('click', '.function.predefined-function', function (e) {
    e.preventDefault()
    e.stopPropagation()

    const templt = $(e.target).data('template')
    $root.find('trix-editor').get(0).editor.insertString(templt)
  })
})
